import { computed, defineComponent, ref } from "vue"
import { Field } from "vant"
import classes from "./index.module.less"

export default defineComponent({
  name: "MobileInput",
  props: {
    modelValue: { type: [String, Number], default: "" },
    readonly: Boolean,
    disabled: Boolean,
    placeholder: String,
    config: { type: Object, default: () => ({}) }
  },
  emits: ["update:modelValue"],
  setup(props, { slots, emit, expose }) {
    const insideValue = computed({
      get() {
        return props.modelValue
      },
      set(newValue) {
        emit("update:modelValue", newValue)
      }
    })

    const inputProps = computed(() => {
      const { autosize } = props.config
      return {
        readonly: props.readonly,
        disabled: props.disabled,
        placeholder: props.placeholder,
        class: classes.input,
        type: autosize ? "textarea" : "text",
        rows: 1,
        ...props.config
      }
    })

    const inputRef = ref(null)
    expose({
      inst: inputRef
    })

    return () => (
      <Field
        ref={inputRef}
        vModel={insideValue.value}
        vSlots={slots}
        {...inputProps.value}
      />
    )
  }
})
